<form [formGroup]="form">
  <p-sidebar (onHide)="this.hide()" [style]="{'z-index':90, width: '380px' , backgroundColor:'#F5F5F5'}" appendTo="dashboard-container" [(visible)]="sidebarVisible" position="right">
    
    <div class="mt-3">
      <div class="block-container p-2 pt-4">  
        <!--
        <split-select-button 
        [style]="{'text-transform': 'unset','font-weight':'unset !important','font-size':'11px'}" 
        (onOptionClick)="toogleAgendamentosBtn($event)" 
        [options]="optionAgendamentosBtn"></split-select-button>-->
        <div class="p-3"> 
            <p class="title">
              Paciente
            </p>
            <div class="w-full">
                <p-dropdown 
                styleClass="w-21rem select-custom-sm" 
                    [options]="pacientes" 
                    formControlName="pacienteBusca"
                    [filter]="true" 
                    filterBy="name" 
                    [showClear]="true" 
                    placeholder="Buscar paciente por nome ou CPF">
        
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div class="flex align-items-center gap-2">
                            
                            <div>{{ selectedOption?.name }}</div>
                        </div>
                    </ng-template>
                    <ng-template let-country pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div>{{ country?.name }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="mt-3">
            <span class="option-label-1">Adicionar paciente</span>
            </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
        <div class="block-container p-2">  
          <div class="p-3 pt-0"> 
              <p class="title">
                Lista de espera
              </p>
              <div>
                <p-radioButton formControlName="listaEspera" value="1" label="Somente esse profissional"></p-radioButton>
              </div>
              <div class="mt-3">
                <p-radioButton formControlName="listaEspera" value="2" label="Todos da especialidade"></p-radioButton>
              </div>
              <div class="mt-5">
                <p-dropdown 
                    styleClass="w-full custom-dropdown select-custom-sm"
                    formControlName="unidade"
                    [options]="['','Leme','Bota fogo','Rio de janeiro','Campinas']" 
                    placeholder="Selecionar unidades"
                    inputId="unidade"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-buildings custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                </p-dropdown>
              </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div class="block-container p-2">  
          <div class="p-3 pt-0"> 
              <p class="title">
                Detalhes da consulta
              </p>
              
              <span class="p-float-label">
                <p-calendar appendTo="body" 
                styleClass="w-22rem custom-calendar-input select-custom-sm" 
                [showIcon]="true"></p-calendar>
                <label for="data">Data</label>
              </span>

              <div class="mt-4 w-full flex align-items-center" style="text-align: left;">
                  <p-dropdown 
                  styleClass="w-12rem custom-dropdown select-custom-sm"
                  formControlName="hora1"
                  [options]="['','10:20','11:20']" 
                  placeholder="hora"
                  inputId="hora"
                 >
                    <ng-template let-item pTemplate="selectedItem">
                        <i class="bi bi-clock custom-dropdown-icon mr-2 ml-1"></i>
                        {{item}}
                    </ng-template>
                 </p-dropdown>
                 <span class="option-label-1 ml-4">Personalizado</span>
              </div>
            
              <div class="mt-5">
                <p-dropdown 
                    styleClass="w-full custom-dropdown select-custom-sm"
                    formControlName="frequencia"
                    [options]="['','Não se repete','repete']" 
                    placeholder="frequencia"
                    inputId="frequencia"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-arrow-left-right custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                </p-dropdown>
              </div>
              <div class="mt-5">
                <p-dropdown 
                    styleClass="w-full custom-dropdown select-custom-sm"
                    formControlName="programacao"
                    [options]="['','Programado','Não programado']" 
                    placeholder="programacao"
                    inputId="programacao"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-circle-fill custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                </p-dropdown>
              </div>
              <div class="mt-5">
                <p-dropdown 
                    styleClass="w-full custom-dropdown select-custom-sm"
                    formControlName="paciente"
                    [options]="['','Carlos','Rodrigo','Rogerio','Felipe']" 
                    placeholder="paciente"
                    inputId="paciente"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-person-circle custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                </p-dropdown>
              </div>
              <div class="mt-5">
                <p-dropdown 
                    styleClass="w-full custom-dropdown select-custom-sm"
                    formControlName="bairro"
                    [options]="['','Vila nova']" 
                    placeholder="bairro"
                    inputId="bairro"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i style="color:#7986CB" class="bi bi-circle-fill custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                </p-dropdown>
              </div>
              <div class="mt-5">
                <span class="p-input-icon-left w-full select-custom-sm">
                    <i class="bi bi-briefcase"></i>
                    <input type="text"
                    [disabled]="true" 
                     class="w-full" 
                     pInputText 
                     placeholder="Consulta fisioterapia"/>
                </span>
              </div>
              <div class="mt-5 flex">
                <div>
                    <p-dropdown 
                    styleClass="w-7rem mr-2 select-custom-sm"
                    formControlName="hora"
                    [options]="['','12:00','14:00']" 
                    placeholder="Hora"
                    inputId="hora">
                        <ng-template let-item pTemplate="selectedItem">
                            {{item}}
                        </ng-template>
                    </p-dropdown>
                </div>
                <div>
                    <span class="p-input-icon-left w-full">
                        <i class="bi bi-coin"></i>
                        <input type="text" 
                        class="w-full select-custom-sm" 
                        pInputText 
                        placeholder="Valor"/>
                    </span>
                </div>
              </div>
          </div>
        </div>
      </div>
      
      <div class="mt-3">
        <div class="block-container p-2">  
          <div class="p-3 pt-0"> 
              <p class="title">
                Pagamento
              </p>
              <div>
                <i class="bi bi-coin mr-2"></i>
                <span class="payment-value-label">Total: R$260,00</span>
              </div>
              <div class="mt-4 flex">
                <span class="status-container mr-3">
                    Aguardando
                </span>
                <span pRipple>
                    <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M5.2941 5.39453H4.36273C3.86871 5.39453 3.39491 5.59078 3.04558 5.94011C2.69625 6.28944 2.5 6.76324 2.5 7.25726V15.6396C2.5 16.1336 2.69625 16.6074 3.04558 16.9567C3.39491 17.306 3.86871 17.5023 4.36273 17.5023H12.745C13.2391 17.5023 13.7129 17.306 14.0622 16.9567C14.4115 16.6074 14.6078 16.1336 14.6078 15.6396V14.7082" stroke="#585050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.6758 3.5308L16.4699 6.3249M17.7599 5.00702C18.1267 4.6402 18.3327 4.14269 18.3327 3.62394C18.3327 3.10518 18.1267 2.60767 17.7599 2.24086C17.393 1.87404 16.8955 1.66797 16.3768 1.66797C15.858 1.66797 15.3605 1.87404 14.9937 2.24086L7.15625 10.0504V12.8445H9.95035L17.7599 5.00702Z" stroke="#585050" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                </span>
              </div>
              <div class="mt-4">
                <span class="option-label-1">Vincular pagamento</span>
              </div>
          </div>
        </div>
      </div>  
      <div class="mt-3">
        <div class="block-container p-2">  
        
          <div class="p-3 pt-0"> 
              <p class="title">
                Marketing autorizações
              </p>
              <div class="mt-5">
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Disparo de confirmaçãoes e cancelamentos de consultas</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Lembrete do agendamento</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Pré-Confirmação</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Avaliações</span>
                    </div>
                </div>
                <div class="mt-3">
                    <div class="switch-line">
                        <p-inputSwitch></p-inputSwitch>
                        <span class="label-switch ml-2">Campanhas Marketing</span>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div> 
      <div class="mt-3">
        <div class="block-container p-2">  
          <div class="p-3 pt-0"> 
              <p class="title">
                Notas
              </p>
              <div class="mt-4">
                <span class="p-float-label">
                    <textarea class="w-21rem" id="float-input" rows="5" cols="30" pInputTextarea></textarea>
                    <label for="float-input">Escreve sua nota</label>
                </span>
              </div>
          </div>
        </div>
      </div>   
      <div class="mt-3">
        <div class="block-container p-2">  
          <div class="p-3 pt-0"> 
            <p class="title">
              Quais notificações enviamos
            </p>
            <div class="mt-4">
              <div class="flex align-items-center mt-2">
                  <p-checkbox label="Confirmação do agendamento" value="1"></p-checkbox>
              </div>
              <div class="flex align-items-center mt-2">
                  <p-checkbox label="Lembrete do agendamento"  value="2"></p-checkbox>
              </div>
              <div class="flex align-items-center mt-2">
                  <p-checkbox label="Lista de espera" value="3"></p-checkbox>
              </div>
              <div class="footer">
                  <button  (click)="hide()" pRipple pButton class="p-button-outlined p-button-secondary flex justify-content-center ">
                      CANCELAR
                  </button>
                  <button  (click)="hide()" pRipple pButton class="flex justify-content-center">
                      SALVAR
                  </button>
              </div>
            </div>  
          </div>
        </div>
      </div>                  
    </p-sidebar>
</form>